import { Injectable } from '@angular/core';
import { Offerte } from '../model/offerte';
//import { Iren10x2ele } from './archivioofferte/iren10x2ele';
//import { Iren10x2gas } from './archivioofferte/iren10x2gas';
import { IrenWeb } from '../archivioofferte/irenweb';
//import { iren10x3ele } from './archivioofferte/iren10x3ele';
import { iren10x3SpecialLuce } from '../archivioofferte/iren10x3SpecialLuce';
import { iren10x3SpecialWebLuce } from '../archivioofferte/iren10x3SpecialWebLuce';
import { iren10x3SpecialGas } from '../archivioofferte/iren10x3SpecialGas';
// import { irenbloccaenergia } from './archivioofferte/irenbloccaenergia';
//import { iren10x3gas } from './archivioofferte/iren10x3gas';
import { irenAnnoLuce } from '../archivioofferte/irenAnnoLuce';
//import { irenGasPrezzoFisso } from './archivioofferte/irenGasPrezzoFisso';
import { irenGasSicuro } from '../archivioofferte/irenGasSicuro';
import { irenwebGas } from '../archivioofferte/irenwebGas';
import { iren10X2LuceServizi } from '../archivioofferte/iren10X2LuceServizi';
//import { iren10x2Dual } from './archivioofferte/iren10x2Dual';
// import { grittiSempliceCasa } from '../archivioofferte/grittiSempliceCasa';
// import { grittiSempliceCasaGas } from '../archivioofferte/grittiSempliceCasaGas';
// import { grittiSempliceIMPRESA } from '../archivioofferte/grittiSempliceIMPRESA';
import { grittiVeloceIMPRESA } from '../archivioofferte/grittiVeloceIMPRESA';
import { grittiVeloceIMPRESAgas } from '../archivioofferte/grittiVeloceIMPRESAgas';
import { grittiSempliceIMPRESAGAS } from '../archivioofferte/grittiSempliceIMPRESAGAS';
import { grittiZeroCanoneGas } from '../archivioofferte/grittiZeroCanoneGas';
import { grittiZeroCanoneEle } from '../archivioofferte/grittiZeroCanoneEle';
import { grittiZeroCanoneLuceGas } from '../archivioofferte/grittiZeroCanoneLuceGas';
import { meiCanoneZero } from '../archivioofferte/meiCanoneZero';
import { meiCanoneZeroPlusPlus } from '../archivioofferte/meiCanoneZeroPlusPlus';
import { meiCanoneZeroDual } from '../archivioofferte/meiCanoneZeroDual';
import { meiCanoneZeroGAS } from '../archivioofferte/meiCanoneZeroGAS';
import { meiCanoneZeroGASPlusPlus } from '../archivioofferte/meiCanoneZeroGASPlusPlus';
import { meiCanoneZeroDualPlusPlus } from '../archivioofferte/meiCanoneZeroDualPlusPlus';
import { meiSimpleEle } from '../archivioofferte/meiSimpleEle';
// import { meiSimpleElePlusPlus } from '../archivioofferte/meiSimpleElePlusPlus';
// import { meiSimpleGasPlusPlus } from '../archivioofferte/meiSimpleGasPlusPlus';
import { meiSimpleGas } from '../archivioofferte/meiSimpleGas';
import { meiSimpleDual } from '../archivioofferte/meiSimpleDual';
import { Irenled12 } from '../archivioofferte/irenled12';
import { Irenled8 } from '../archivioofferte/irenled8';
import { irenwebDual } from '../archivioofferte/irenwebDual';
//import { irenGasPrezzoFissoBloccaEnergia } from './archivioofferte/irenGasPrezzoFissoBloccaEnergia';
import { iren10x3SpecialDual } from '../archivioofferte/iren10x3SpecialDual';
import { Datipreventivo } from '../model/datipreventivo';
import { ComparatoretaskService } from './comparatoretask.service';
import { iren10x3SpecialWebGas } from '../archivioofferte/iren10x3SpecialWebGas';
import { iren10x3SpecialWebDual } from '../archivioofferte/iren10x3SpecialWebDual';
import { IrenTuttoOkLuce } from '../archivioofferte/IrenTuttoOkLuce';
import { iren10x3Gas} from '../archivioofferte/iren10x3Gas';
import { irenTuttoOkLuceE10x3Gas } from '../archivioofferte/irenTuttoOkLuceE10x3Gas';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment.prod';

@Injectable()
export class OfferteServiceService {


  private lst: Array<Offerte>;
  constructor(private servicecomparatore: ComparatoretaskService, private http:HttpClient) {
    this.lst = [

      //Iren10x2ele.offerta() ,
      //Iren10x2gas.offerta(),
      //iren10x3ele.offerta(),
      // iren10x3SpecialLuce.offerta(),
      // iren10x3SpecialGas.offerta(),
      // iren10x3SpecialDual.offerta(),

      // iren10x3SpecialWebLuce.offerta(),
      // iren10x3SpecialWebGas.offerta(),
      // iren10x3SpecialWebDual.offerta(),

      IrenTuttoOkLuce.offerta(),
      iren10x3Gas.offerta(),
      irenTuttoOkLuceE10x3Gas.offerta(),
      //iren10x3gas.offerta(),
      //irenbloccaenergia.offerta(),
      //irenGasPrezzoFisso.offerta(),
      irenGasSicuro.offerta(),
      irenAnnoLuce.offerta(),
      iren10X2LuceServizi.offerta(),
      IrenWeb.offerta(),
      irenwebGas.offerta(),
      //iren10x2Dual.offerta(),,
      Irenled12.offerta(),
      Irenled8.offerta(),
      irenwebDual.offerta(),
      //irenGasPrezzoFissoBloccaEnergia.offerta(),
      // grittiSempliceCasa.offerta(),
      // grittiSempliceCasaGas.offerta(),
      // grittiSempliceIMPRESA.offerta(),
      grittiVeloceIMPRESA.offerta(),
      grittiVeloceIMPRESAgas.offerta(),
      // grittiSempliceIMPRESAGAS.offerta(),
      grittiZeroCanoneGas.offerta(),
      grittiZeroCanoneEle.offerta(),
      grittiZeroCanoneLuceGas.offerta(),
      // meiCanoneZero.offerta(),
      meiCanoneZeroPlusPlus.offerta(),
      // meiCanoneZeroDual.offerta(),
      // meiCanoneZeroGAS.offerta(),
      meiCanoneZeroGASPlusPlus.offerta(),
      meiCanoneZeroDualPlusPlus.offerta(),
      meiSimpleEle.offerta(),
      // meiSimpleElePlusPlus.offerta(),
      // meiSimpleGasPlusPlus.offerta(),
      meiSimpleGas.offerta(),
      meiSimpleDual.offerta()


    ]
  }

  public getOfferte(): Observable< Array<Offerte> >{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })};
    var url=environment.urlbase + "/api/offerte/getOffertes";
    return this.http.get<Array<Offerte>>(url, httpOptions);
  };
  
  public getOfferta(id: number): Observable<Offerte> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })};
    var url= environment.urlbase + "/api/offerte/getOffertasbyId/" + id.toString();
   
    return this.http.get<Offerte>(url, httpOptions);     
  };

  public getOfferteByIdFornitoreIdComodity(id_fornitore: number, id_comodity: number): Observable<Array<Offerte>> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })};
    var url= environment.urlbase + "/api/offerte/getOfferteByIdFornitoreIdComoditys/" + id_fornitore.toString() + "/" + id_comodity.toString();
   
    return this.http.get<Array<Offerte>>(url, httpOptions);     
  };
  
  public getOfferteAlternativeByIdFornitoreIdComodity(id_fornitore: number, id_comodity: number): Observable<Array<Offerte>> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })};
    var url= environment.urlbase + "/api/offerte/getOfferteAlternativeByIdFornitoreIdComoditys/" + id_fornitore.toString() + "/" + id_comodity.toString();
   
    return this.http.get<Array<Offerte>>(url, httpOptions);     
  };






  public getOfferteByIdFornitore(id_fornitore: number): Observable<Array<Offerte>> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })};
    var url= environment.urlbase + "/api/offerte/getOfferteByIdFornitores/" + id_fornitore.toString();
   
    return this.http.get<Array<Offerte>>(url, httpOptions);     
  };

  public getOffertePunta(): Observable<Array<Offerte>> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var url= environment.urlbase + "/api/offerte/getOffertePuntas";

    return this.http.get<Array<Offerte>>(url, httpOptions);

    //var lstOffertePunta = [129, 310, 207, 118];
    //
    //var ret = new Array<Offerte>();
    //for (let item of lstOffertePunta) {
    //
    //  ret.push(this.lst.filter(o => o.Id_Offerta == item)[0]);
    //}
    //return ret;
    
    // return this.lst.filter( o => lstOffertePunta.indexOf(o.Id_Offerta)>=0 ) ;
  };


  public getOfferteAlternativeOfferta(id_fornitore: number, id_comodity: number): Observable<Array<Offerte>> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })};
    var url= environment.urlbase + "/api/offerte/getOfferteAlternativeOffertas/" + id_fornitore.toString() + "/" + id_comodity.toString();
   
    return this.http.get<Array<Offerte>>(url, httpOptions);     
  };


  //*********fatto da noi*********//

  // public getOfferteComparatore(dati: Datipreventivo): Observable<Array<Offerte>> {
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json'
  //     })};
  //   var url= environment.urlbase + "/api/Comparatore/Comparata/" + dati.toString();
   
  //   return this.http.get<Array<Offerte>>(url, httpOptions);     
  // };




  public getOfferteComparatore(dati: Datipreventivo): Observable< Array<Offerte>> {

    return this.servicecomparatore.compara(dati, this.lst);
  };
}





// WEBPACK FOOTER //
// ./src/app/service/offerte-service.service.ts